import { ListColumnHeaderComponent } from '../list.column.header.component';

export class ListColumnHeaderSortEvent {
    public column: ListColumnHeaderComponent;
    public isAsc: boolean;

    constructor(column: ListColumnHeaderComponent, isAsc: boolean) {
        this.column = column;
        this.isAsc = isAsc;
    }
}




// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/list/column.header/events/sort.event.ts